parseTokenMM